export default __webpack_public_path__ + "assets/images/turtle-user-avatar-5119646fbc5f82aca92b34af7bd550af.png";